import * as React from "react";
const SvgButtonYoutube = (props) => /* @__PURE__ */ React.createElement("svg", {
	id: "Social-Video-Youtube-Clip--Streamline-Streamline-3.0",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	height: 24,
	width: 24,
	...props
}, /* @__PURE__ */ React.createElement("desc", null, "\n		Social Video Youtube Clip Streamline Icon: https://streamlinehq.com\n	"), /* @__PURE__ */ React.createElement("defs", null), /* @__PURE__ */ React.createElement("title", null, "social-video-youtube-clip"), /* @__PURE__ */ React.createElement("path", {
	d: "M23.25 7.44A3.44 3.44 0 0 0 19.81 4H4.19A3.44 3.44 0 0 0 0.75 7.44v9.12A3.44 3.44 0 0 0 4.19 20h15.62a3.44 3.44 0 0 0 3.44 -3.44ZM9.5 15.94V7.28l6.77 4.33Z",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}));
export { SvgButtonYoutube as ReactComponent };
